import * as yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from 'react-query';
import { yupErrorMsg } from '../../../../components/atoms/const';
import api from '../../../../components/api';

/* eslint-disable */
function useAddInvoice() {
  const { ticketId } = useParams();
  const renderDate = (date: Date): string => `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

  const navigation = useNavigate();
  const navigateToLanding = () => navigation('/customer-support?type=service');

  const { mutate: addServiceInvoice, isLoading: addServiceInvoiceLoad } = useMutation(api.customerSupport.addServiceInvoice, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      alert('success');
      navigateToLanding();
    },
    onError: (error) => {
      console.log(error);
      alert('error');
    },
  });

  const yupSchema = yup.object({
    serviceDate: yup.string().required(yupErrorMsg.SERVICE_DATE_EMPTY),
    parts: yup.array().of(
      yup.object({
        price: yup.number().min(0, yupErrorMsg.PART_PRICE_POSITIVE).required(yupErrorMsg.PART_PRICE_EMPTY),
        // name: yup.string().required(yupErrorMsg.PART_NAME_EMPTY),
      }),
    ),
    laborHour: yup.number().min(0, yupErrorMsg.LABOUR_HOUR_POSITIVE).required(yupErrorMsg.LABOUR_HOUR_EMPTY),
    laborRate: yup.number().min(0, yupErrorMsg.LABOUR_RATE_POSITIVE).required(yupErrorMsg.LABOUR_RATE_EMPTY),
    description: yup.string().required(yupErrorMsg.DESCRIPTION_EMPTY),
    billAmount: yup.number().min(0, yupErrorMsg.BILL_AMOUNT_POSITIVE).required(yupErrorMsg.BILL_AMOUNT_EMPTY),
    discount: yup.number().min(0, yupErrorMsg.DISCOUNT_POSITIVE),
  });
  const formik = useFormik({
    initialValues: {
      serviceId: parseInt(ticketId!, 10),
      serviceDate: new Date(),
      parts: [
        { price: 0, name: '' },
        { price: 0, name: '' },
      ],
      laborHour: 0,
      laborRate: 0,
      description: '',
      discount: 0,
      billAmount: 0,
    },
    validationSchema: yupSchema,
    onSubmit: (values) => addServiceInvoice({
      ...values,
      serviceDate: renderDate(values.serviceDate),
      parts: values.parts.filter(p => p.name).map((x) => `${x.name}: ${x.price}`),
    }),
  });

  return {
    formik,
    addServiceInvoiceLoad,
    navigateToLanding,
  };
}

export default useAddInvoice;
